import { render, staticRenderFns } from "./product-sizes.vue?vue&type=template&id=165b274f&scoped=true"
import script from "./product-sizes.vue?vue&type=script&lang=js"
export * from "./product-sizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b274f",
  null
  
)

export default component.exports